"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../primitives");
var utils_1 = require("../../utils");
function identifier(baseType) {
    if (baseType === void 0) { baseType = primitives_1.string; }
    // TODO: MWE: this seems contrived, let's not assert anything and support unions, refinements etc.
    if (baseType !== primitives_1.string && baseType !== primitives_1.number)
        utils_1.fail("Only 'types.number' and 'types.string' are acceptable as type specification for identifiers");
    return {
        isIdentifier: true,
        primitiveType: baseType
    };
}
exports.identifier = identifier;
function isIdentifierFactory(thing) {
    return typeof thing === "object" && thing && thing.isIdentifier === true;
}
exports.isIdentifierFactory = isIdentifierFactory;
//# sourceMappingURL=identifier.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/utility-types/identifier.js
// module id = 104
// module chunks = 0